// Follow-up link helpers — pre-fill WhatsApp / Email with the visitor's name + intro.

export function firstName(name) {
  const cleaned = String(name || "").replace(/^(mr|mrs|ms|miss|dr|prof)\.?\s+/i, "").trim();
  return cleaned.split(/\s+/)[0] || "there";
}

export function followupMessage(v) {
  const fn = firstName(v.name);
  const exh = v.exhibition_name || "the exhibition";
  return (
    `Hi ${fn}, thank you for visiting Manik India at ${exh}. ` +
    `It was a pleasure connecting with you. I'd be glad to share more about our products ` +
    `and explore how we can work together. Looking forward to staying in touch.`
  );
}

export function waLink(v) {
  const digits = String(v.phone || "").replace(/\D/g, "");
  if (digits.length < 6) return null;
  return `https://wa.me/${digits}?text=${encodeURIComponent(followupMessage(v))}`;
}

export function mailtoLink(v) {
  const email = String(v.email || "").trim();
  if (!email || !email.includes("@")) return null;
  const subject = `Great meeting you at ${v.exhibition_name || "the exhibition"}`;
  return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(followupMessage(v))}`;
}

// Booth photo bundled in /public — shared via the native Share sheet (image + caption).
export const BOOTH_PHOTO_URL = `${process.env.PUBLIC_URL || ""}/manik-booth.jpg`;

// Attempts to share the booth photo (with the follow-up text as caption) via the
// device's native share sheet. Returns a status string the caller can toast on:
//   "shared" | "unsupported" | "cancelled" | "error"
export async function shareBoothPhoto(v) {
  try {
    const res = await fetch(BOOTH_PHOTO_URL);
    if (!res.ok) throw new Error("fetch failed");
    const blob = await res.blob();
    const file = new File([blob], "manik-booth.jpg", { type: blob.type || "image/jpeg" });
    const data = { files: [file], text: followupMessage(v) };
    if (navigator.canShare && navigator.canShare({ files: [file] }) && navigator.share) {
      await navigator.share(data);
      return "shared";
    }
    return "unsupported";
  } catch (e) {
    if (e && e.name === "AbortError") return "cancelled";
    return "error";
  }
}
